module.exports = __webpack_public_path__ + "img/invalid.0af5da71.svg";